import { code } from "@spscommerce/utils";

export const SpsWorkflowExamples = {
    href: {
        label: "With Href",
        examples: {
            href: {
                template: code`
                <sps-workflow icon="list-summary" title="Workflow">
                    <sps-workflow-step icon="heart" title="Name of Step">
                        <sps-workflow-document>
                            <a href="https://github.com/SPSCommerce/ui-angular" target="_blank">Document Name</a>
                            <sps-workflow-document-status icon="status-error">Status</sps-workflow-document-status>
                        </sps-workflow-document>
                        <sps-workflow-document>
                            <span>Document Name</span>
                            <sps-workflow-document-status icon="status-error">Status</sps-workflow-document-status>
                        </sps-workflow-document>
                    </sps-workflow-step>
                    <sps-workflow-step icon="status-ok" title="Done">
                    </sps-workflow-step>
                </sps-workflow>`
            }
        }
    },
    routerLink: {
        label: "With RouterLink",
        examples: {
            routerLink: {
                template: code`
                <sps-workflow icon="list-summary" title="Workflow">
                    <sps-workflow-step icon="heart" title="Name of Step">
                        <sps-workflow-document>
                            <a [routerLink]="['/tag']">
                                Document Name
                            </a>
                            <sps-workflow-document-status icon="status-error">
                                Status
                            </sps-workflow-document-status>
                        </sps-workflow-document>
                    </sps-workflow-step>
                    <sps-workflow-step icon="status-ok" title="Done">
                    </sps-workflow-step>
                 </sps-workflow>`
            }
        }
    },

};
